module.exports = __webpack_public_path__ + "img/tomy_dorama.a819c489.png";